// 事件总线
// $on 监听某一个事件
// $off 取消监听
// $emit 触发事件
import Vue from 'vue'
const app = new Vue({})

Vue.prototype.$bus = app

export default app